import { MoovConfigurationStatusDTO } from "../DTO/moovConfigurationStatusDTO";

export class MoovConfigurationStatus {
    public id!: number;
    public customerName!: string;
    public customerId!: number;
    public clientName!: string;
    public clientId!: number;
    public moovName!: string;
    public moovDefinitionId!: number;
    public status!: number; //0=Draft, 1=Testing, 2=Active, 3=Inactive
    public filenameStartsWith!: string;
    public filenameContains!: string;
    public added!: Date;
    public edited!: Date;
    public lastExecutedMoovInstanceId!: number;
    public lastExecutedStatus!: number; //0=created, 1=in process, 2=completed, 3=failed, 4=deleted, 5=suspended
    public lastAddedAt!: Date;
    public lastExecutedOnOlderConfiguration!: boolean;

    get moovConfigurationDescription(){
        return this.filenameStartsWith + ' (' + (this.filenameContains?this.filenameContains:'')+')';
    }

    public static mapFromDTO(param: MoovConfigurationStatusDTO): MoovConfigurationStatus {
        if(!param) throw new Error("param is null");
        let obj = new MoovConfigurationStatus();
        try
        {
            obj.id = param.id;
            obj.customerName = param.customerName;
            obj.customerId = param.customerId;
            obj.clientName = param.clientName;
            obj.moovName = param.moovName;
            obj.moovDefinitionId = param.moovDefinitionId;
            obj.status = param.status;
            obj.filenameStartsWith = param.filenameStartsWith;
            obj.filenameContains = param.filenameContains;
            obj.added = new Date(param.added);
            if(param.edited)obj.edited = new Date(param.edited);
            if(param.lastExecutedMoovInstanceId){
                obj.lastExecutedMoovInstanceId = param.lastExecutedMoovInstanceId;
                obj.lastExecutedStatus = param.lastExecutedStatus;
                if(param.lastAddedAt)obj.lastAddedAt = new Date(param.lastAddedAt);
                obj.lastExecutedOnOlderConfiguration = param.lastExecutedOnOlderConfiguration;
            }
        } 
        catch (e){
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param: MoovConfigurationStatus): MoovConfigurationStatusDTO {
        if(!param) throw new Error("param is null");
        let dto = new MoovConfigurationStatusDTO();
        try 
        {
            dto.id = param.id;
            dto.customerName = param.customerName;
            dto.customerId = param.customerId;
            dto.clientName = param.clientName;
            dto.moovName = param.moovName;
            dto.moovDefinitionId = param.moovDefinitionId;
            dto.status = param.status;
            dto.filenameStartsWith = param.filenameStartsWith;
            dto. filenameContains = param.filenameContains;
            dto.added = param.added.toISOString();
            if(param.edited)dto.edited = param.edited.toISOString();
            if(param.lastExecutedMoovInstanceId){
                dto.lastExecutedMoovInstanceId = param.lastExecutedMoovInstanceId;
                dto.lastExecutedStatus = param.lastExecutedStatus;
                if(param.lastAddedAt)dto.lastAddedAt = param.lastAddedAt.toISOString();
                dto.lastExecutedOnOlderConfiguration = param.lastExecutedOnOlderConfiguration;
            }
        }
        catch (e){
            console.log(e);
        }
        return dto;
    }

    get displayStatus(){
        switch(this.status){
            case 0:
                return "Draft";
            case 1:
                return "Testing";
            case 2:
                return "Active";
            case 3:
                return "Inactive";
            default:
                return "Unknown";
        }
    }

    get displayExecutionStatus(){
        switch(this.lastExecutedStatus){
            case 0:
                return "created";
            case 1:
                return "processing";
            case 2:
                return "completed";
            case 3:
                return "failed"
            case 4:
                return "deleted"
            case 5:
                return "suspended"
            default:
                return "none"
        }
    }
}

